import $ from "jquery";

export const eventsPostLink = () => {
    $('a[data-method="post"]').click(function (event) {
        event.preventDefault();

        const url = $(this).attr('href');
        const csrf = $('meta[name=csrf-token]').attr('content');
        const param = $('meta[name=csrf-param]').attr("content");

        let data = {};
        data[param] = csrf;

        $.ajax({
            url: url,
            type: 'post',
            data: data,
            statusCode: {
                302: function (data) {
                    window.location.href = data.getResponseHeader('X-Redirect');
                },
            },
        });

        return false;
    });
};
